import { createTheme } from '@mui/material/styles';

// src/baseTheme.ts
var baseTheme = createTheme({
  palette: {
    primary: {
      main: "#cd9bd6",
      light: "#ffccff",
      dark: "#9b6ca4"
    },
    secondary: {
      main: "#a4d69b",
      light: "#d6ffcc",
      dark: "#74a46c"
    }
  },
  shape: {
    borderRadius: 12
  }
});
var baseTheme_default = baseTheme;

export { baseTheme_default };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-YD2QUJX6.mjs.map